<div id="register-waiting">
    <p [innerHTML]="'REGISTER_WAITING_DESCRIPTION' | translate"></p>
    <p>{{ 'REGISTER_WAITING_HINT' | translate }}</p>
    <button (click)="requestConfirmationMail()" type="button"
            class="btn btn-blue my-2">{{ 'REGISTER_WAITING_BTN_LABEL' | translate }}
        <fa-icon class="ms-2" [icon]="['fal', 'undo']"></fa-icon>
    </button>
</div>
